/* eslint-disable max-len */
/* eslint-disable max-lines */
import React, {useEffect, useState} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table} from 'semantic-ui-react';
import TablePaginator from './commons/tablePaginator';
import './styles.scss';
import {nullFilter} from '../../../common/components/commercialTable/utils';
import {ColumnsData, ColumnsFilter, ColumnsHeader} from './commons/columns';
import {invoicesPageSizesCustomOrders} from '../../constants/lists';


/**
 * JSX Component to render a table.
 * @param {Array} columns Array of columns definitions.
 * @param {Array} data Array of data to manage in table.
 * @param {React.Component} defaultColumnFilter OPTIONAL. Default filter component.
 * @param {Object} tableProps OPTIONAL. Semantic UI Table props.
 * @param {String} tableType OPTIONAL. 'raw' (default): Shows default Semantic UI Table. 'fixed': Semantic UI Table with fixed header.
 * @param {() => void} setFilteredData OPTIONAL. Callback that returns filtered data.
 * @param {String} tableWrapperStyles OPTIONAL. CSS classes to handle table width size.
 * @param {Boolean} pagination OPTIONAL. Add pagination to table.
 * @param {Array} lineColor OPTIONAL. Array of colors (string) to color rows.
 * @param {{'key': '', 'values': [], 'rgbColor': ''}} colorLineByProperty OPTIONAL. Object to color a row under a specific contidion, if key contains values, apply rgbColor.
 * @param {Boolean} isSmallCell OPTIONAL. Reduce cell size.
 * @param {Array} pagesSizeList OPTIONAL. Array of Object to render in page size dropdown.
 * @param {Int} defaultPagination OPTIONAL. Set default size page.
 * @param {customColumnsHook} customColumnsHook OPTIONAL. Add custom columns logic.
 * @returns
 */
const CommercialTable = ({
  columns,
  data,
  defaultColumnFilter,
  tableProps = {},
  tableType = 'raw',
  fixedColumns = [],
  setFilteredData = (val) => null,
  tableWrapperStyles = '',
  pagination = true,
  lineColor = ['#d8ebf3', '#fff'],
  colorLineByProperty = null,
  isSmallCell = false,
  pagesSizeList = invoicesPageSizesCustomOrders,
  defaultPagination = 200,
  customColumnsHook = (columns, i) => columns,
  useTableProps = null,
  handleClickLine = (val) => null,
  resetAllFilters = null,
  setResetAllFilters = (val) => null,
  resetFiltersValue = [],
}) => {
  const defaultUseTableProps = {
    columns,
    data,
    'defaultColumn': {'Filter': defaultColumnFilter, 'filter': nullFilter},
    'initialState': {'pageIndex': 0, 'pageSize': defaultPagination},
    'autoResetFilters': false,
    'filter': nullFilter,
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    filteredRows,
    setAllFilters,
    'state': {pageIndex, pageSize},
  } = useTable(
    useTableProps || defaultUseTableProps,
    useFilters,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns, i) => customColumnsHook(columns, i));
    }
  );
  const [filteredRowsLength, setFilteredRowsLength] = useState(0);
  useEffect(() => {
    if (filteredRows.length !== filteredRowsLength) {
      setFilteredRowsLength(filteredRows.length);
      setFilteredData(filteredRows);
    }
  }, [filteredRows]);
  const lineColors = lineColor.length === 1 ? [...lineColor, ...lineColor] : lineColor;
  const isTableFixed = tableType === 'fixed';

  useEffect(() => {
    if (resetAllFilters) {
      setAllFilters(resetFiltersValue);
      setResetAllFilters(false);
    }
  }, [resetAllFilters]);

  return (
    <>
      <div
        className={isTableFixed ?
          `${tableWrapperStyles ? tableWrapperStyles : 'commercial-by-line-table'} commercial-table-wrapper` : 'commercial-table-wrapper'}
      >
        <Table
          className='interactive'
          {...tableProps}
          {...getTableProps()}
        >
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={100} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) =>
                <ColumnsData
                  fixedColumns={fixedColumns}
                  row={row}
                  prepareRow={prepareRow}
                  colorLineByProperty={colorLineByProperty}
                  lineColors={lineColors}
                  i={i}
                  isTableFixed={isTableFixed}
                  isSmallCell={isSmallCell}
                  handleClickLine={handleClickLine}
                />
              )}
          </Table.Body>
          <Table.Header className={isTableFixed ? 'commercial-sticky-header' : ''}>
            {headerGroups.map((headerGroup, indexi) =>
              <ColumnsHeader
                fixedColumns={fixedColumns}
                indexi={indexi}
                headerGroup={headerGroup}
                isTableFixed={isTableFixed}

              />
            )}
            {!!defaultColumnFilter && headerGroups.map((headerGroup, indexi) =>
              <ColumnsFilter
                fixedColumns={fixedColumns}
                indexi={indexi}
                headerGroup={headerGroup}
                isTableFixed={isTableFixed}
              />
            )}
          </Table.Header>
        </Table>
      </div>
      {pagination && <TablePaginator
        page={page}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
        pagesSizeList={pagesSizeList}
      />}
    </>
  );
};

export default CommercialTable;
